import { render, staticRenderFns } from "./SSNInput.vue?vue&type=template&id=5d46ea55&scoped=true&"
import script from "./SSNInput.vue?vue&type=script&lang=js&"
export * from "./SSNInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d46ea55",
  null
  
)

export default component.exports